import axios from "axios";
import { HOST_URL } from "./Host";

const headers = {
  Accept: "application/json",
  "X-Accept-Version": "2.0",
};

export function addBusinessCreationRequestDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/documents/registration/${reference}`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getBusinessCreationRequestDocuments(
  token,
  reference,
  callback
) {
  return async () => {
    try {
      const res = await axios.get(
        `${HOST_URL}/documents/registration/${reference}`,

        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback(res.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function uploadTicketDocuments(token, reference, formData, callback) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/documents/upload?target=ticket&reference=${reference}`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadRequestGeneralDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/documents/upload?target=request&reference=${reference}`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function uploadCompanyGeneralDocuments(
  token,
  reference,
  formData,
  callback
) {
  return async () => {
    try {
      const res = await axios.post(
        `${HOST_URL}/documents/upload?target=company&reference=${reference}`,
        formData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback({ success: true, message: res.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getTicketDocuments(token, reference, callback) {
  return async () => {
    try {
      const res = await axios.get(
        `${HOST_URL}/documents/general?target=ticket&reference=${reference}`,

        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback(res.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getRequestDocuments(token, reference, callback) {
  return async () => {
    try {
      const res = await axios.get(
        `${HOST_URL}/documents/general?target=request&reference=${reference}`,

        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback(res.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getCompanyDocuments(token, reference, callback) {
  return async () => {
    try {
      const res = await axios.get(
        `${HOST_URL}/documents/general?target=company&reference=${reference}`,

        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      await callback(res.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getGeneralDocuments(token, company, callback) {
  return async () => {
    try {
      const res = await axios.get(
        `${HOST_URL}/documents/general?target=company&reference=${company}`,

        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      callback(res.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}
